import { createSelector } from 'reselect';

export const schemasSelector = createSelector(
    (_, props) => props.marketConfig.get('SEO').schemas,
    inputSchemas => {
        const schemas = { ...inputSchemas };
        const processSchema = schemaKey => {
            if (schemas[schemaKey].baseSchema) {
                const { baseSchema, ...rest } = schemas[schemaKey];

                processSchema(schemas[schemaKey].baseSchema);
                schemas[schemaKey] = { ...schemas[baseSchema], ...rest };
            }
        };

        Object.keys(schemas).forEach(processSchema);
        return schemas;
    }
);
